import { cn } from '@repo/tailwind-config/tailwind.functions'
import Badge from '@repo/ui/badge'
import Button from '@repo/ui/button'
import { CheckListTwoIcon } from '@repo/ui/icons'
import Modal, { MODAL_CONTENT_CLASSNAME } from '@repo/ui/modal'
import { useMutation } from '@tanstack/react-query'
import React, { useState } from 'react'

import { validateMissionToStaffReport } from '../../../api/mission-to-staffs/validate-mission-to-staff-report'
import { useModalManager } from '../../../lib/hooks/use-modal-manager'
import {
  MissionReportStatusEnum,
  missionReportStatusEnumMapping
} from '../../../lib/types/enums/mission/mission-report-status.enum'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import MissionToStaffReportView from '../mission-to-staff-report/mission-to-staff-report-view'

type Props = {
  missionToStaffId: number
  reportStatus: MissionReportStatusEnum
}

const MissionToStaffReportBadge: React.FC<Props> = ({ missionToStaffId, reportStatus }) => {
  const { modalState, toggleModal, closeModel } = useModalManager(['validate'])
  const [status, setStatus] = useState(reportStatus)

  const { mutate, isPending } = useMutation({
    mutationFn: validateMissionToStaffReport,
    onSuccess: () => {
      setStatus(MissionReportStatusEnum.VALIDATED)
      closeModel('validate')
    },
    onError: showAxiosError
  })

  const isValidated = status === MissionReportStatusEnum.VALIDATED
  const canOpenReport = status === MissionReportStatusEnum.SENT || isValidated

  return (
    <div>
      <Badge
        className={cn({ 'cursor-pointer': canOpenReport, 'cursor-default': !canOpenReport })}
        onClick={() => {
          if (canOpenReport) toggleModal('validate')
        }}
        variant={missionReportStatusEnumMapping[status].variant}
        text={<CheckListTwoIcon color={missionReportStatusEnumMapping[status].color} />}
      />

      <Modal
        isOpen={modalState.validate}
        title={'Rapport de mission'}
        icon={CheckListTwoIcon}
        size="medium"
        hideActions
        onCancel={() => closeModel('validate')}
      >
        <div className="w-full divide-y divide-white-active">
          <MissionToStaffReportView
            missionToStaffId={missionToStaffId}
            className={MODAL_CONTENT_CLASSNAME}
          />
          <div className="flex justify-end p-6 space-x-4">
            <Button label="Fermer" variant="ghost" onClick={() => closeModel('validate')} />
            {!isValidated && (
              <Button
                label="Valider le rapport"
                variant="primary"
                loading={isPending}
                onClick={() => {
                  mutate(missionToStaffId)
                }}
              />
            )}
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default MissionToStaffReportBadge
